export interface PayloadValue {
	totalUser: number;
	freeUser: number;
	paidUser: number;
	totalMatches: number;
	totalCruise: number;
}

export interface DashState {
	dashboardItem: PayloadValue;
}
export interface Dash {
	dashboard: DashState;
}
interface DashboardSuccess {
	type: "DASHBOARD_SUCCESS";
	payload: {
		value: PayloadValue;
	};
}

interface DashboardClear {
	type: "CLEAR_DASHBOARD";
	payload: {
		value: {};
	};
}

type Action = DashboardSuccess | DashboardClear;

export const dashboardReducer = (
	state: DashState = {
		dashboardItem: { totalUser: 0, freeUser: 0, paidUser: 0, totalMatches: 0, totalCruise: 0 },
	},
	action: Action
): DashState => {
	switch (action.type) {
		case "DASHBOARD_SUCCESS":
			return {
				...state,
				dashboardItem: action.payload?.value,
			};
		case "CLEAR_DASHBOARD":
			return {
				dashboardItem: { freeUser: 0, paidUser: 0, totalCruise: 0, totalMatches: 0, totalUser: 0 },
			};

		default:
			return state;
	}
};
